import { createFileRoute } from '@tanstack/react-router'

// import { NotificationsPage } from '@/components/NotificationsPage'

export const Route = createFileRoute('/_app/notifications')({
  component: NotificationsPage,
})

function NotificationsPage() {
  return (
    <div>
      {/* <NotificationsPage /> */}
      <h1>Notifications</h1>
    </div>
  )
}
